"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logo_1 = require("./Logo");
exports.default = Logo_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Logo/index.js
// module id = 1713
// module chunks = 8